export const BIND_TYPE = {
  PHONE: 'phone',
  EMAIL: 'email'
}

export const STYLE_BASE_SIZE = 0.0625
export const STYLE_RADIUS_SIZE = STYLE_BASE_SIZE * 6

export const DEFAULT_LOCALE = 'en-SG'

export const COUNTRY_PHONE_CODE = {
  'TW': [
    {
      name: '台灣 (+886)',
      value: '886'
    },
    {
      name: '香港 (+852)',
      value: '852'
    },
    {
      name: '澳門 (+853)',
      value: '853'
    }
  ],
  'ID': [
    {
      name: 'Indonesia (+62)',
      value: '62'
    }
  ],
  'SG': [
    {
      name: 'Singapore (+65)',
      value: '65'
    },
    {
      name: 'Philippines (+63)',
      value: '63'
    },
    {
      name: 'Malaysia (+60)',
      value: '60'
    }
  ],
  'TH': [
    {
      name: 'ประเทศไทย (+66)',
      value: '66'
    }
  ],
  'VN': [
    {
      name: 'Việt Nam (+84)',
      value: '84'
    }
  ]
}

let countryCodeList = []
for (let country in COUNTRY_PHONE_CODE) {
  for (let code of COUNTRY_PHONE_CODE[country]) {
    countryCodeList.push(code.value)
  }
}

export const COUNTRY_CODE_LIST = countryCodeList

export const COUNTRY_TO_RECAPTCHA_LANG = {
  'SG': 'en',
  'TW': 'zh-TW',
  'VN': 'vi',
  'TH': 'th',
  'ID': 'id',
}



// WEBPACK FOOTER //
// ./src/constants/index.js